import script from "./App.vue?vue&type=script&setup=true&lang=js"
export * from "./App.vue?vue&type=script&setup=true&lang=js"

import "./App.vue?vue&type=style&index=0&id=6a2ad88d&lang=less"
import "./App.vue?vue&type=style&index=1&id=6a2ad88d&lang=scss"

const __exports__ = script;

export default __exports__